import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, SYS_SIZE_FIXED_300, SYS_SPACE_FIXED_50, SEM_TYPOGRAPHY_FORMS_LABEL, SEM_BORDER_WIDTH_FORMS_DEFAULT, SYS_SPACE_FIXED_150, getTypographyStyles, SYS_SIZE_FIXED_600, SYS_SPACE_FIXED_25 } from '@oneaudi/unified-web-alpha-common';
export const StyledRadioContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_50};
`;
export const StyledTextContent = styled.div `
  padding-top: ${SYS_SPACE_FIXED_25};
  transition-property: color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledRadioIndicator = styled.div `
  width: ${SYS_SIZE_FIXED_600};
  height: ${SYS_SIZE_FIXED_600};
  box-sizing: border-box;
  border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid
    ${(props) => props.theme.sem.color.forms.surface.control.default.stroke.idle};
  background-color: ${(props) => props.theme.sem.color.forms.surface.control.default.fill.idle};
  flex-shrink: 0;
  transition-property: border-color, color, background-color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    width: ${SYS_SIZE_FIXED_300};
    height: ${SYS_SIZE_FIXED_300};
    background-color: ${(props) => props.theme.sem.color.forms.foreground.control.selected.indicator.idle};
    border-radius: 50%;
    transform: scale(0);
    transform-origin: 50%;
    content: '';
    visibility: hidden;
    transition-property: transform, visibility, height, width, background-color;
    // TODO: token missing;
    transition-duration: 0.1s;
    // TODO: token missing;
    transition-timing-function: ease;
    ${(props) => props.invalid &&
    css `
        background-color: ${props.theme.sem.color.forms.foreground.control
        .selected.indicator.error};
      `}
  }
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  &:checked + ${StyledRadioIndicator}::before {
    transform: scale(1);
    visibility: visible;
  }

  &:focus {
    & + ${StyledRadioIndicator} {
      outline: 2px solid Highlight;
      outline-style: auto;
      outline: 2px solid -webkit-focus-ring-color;
    }
  }

  &:focus:not(:focus-visible) + ${StyledRadioIndicator} {
    outline: none;
  }

  ${(props) => props.invalid &&
    css `
      & + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.default
        .stroke.error};
        background-color: ${props.theme.sem.color.forms.surface.control.default
        .fill.error};
      }

      &:checked:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.selected
        .stroke.error};
        background-color: ${props.theme.sem.color.forms.surface.control.selected
        .fill.error};

        &::before {
          background-color: ${props.theme.sem.color.forms.foreground.control
        .selected.indicator.error};
        }
      }
    `}

  ${(props) => !props.invalid &&
    css `
      &:checked + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.selected
        .stroke.idle};
        background-color: ${props.theme.sem.color.forms.surface.control.selected
        .fill.idle};
      }

      &:hover:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.default
        .stroke.interactive};
        background-color: ${props.theme.sem.color.forms.surface.control.default
        .fill.interactive};
      }

      &:hover:checked:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.selected
        .stroke.interactive};
        background-color: ${props.theme.sem.color.forms.surface.control.selected
        .fill.interactive};

        &::before {
          background-color: ${props.theme.sem.color.forms.foreground.control
        .selected.indicator.interactive};
        }
      }

      &:checked:active:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.selected
        .stroke.interactive};
        background-color: ${props.theme.sem.color.forms.surface.control.selected
        .fill.interactive};

        &::before {
          background-color: ${props.theme.sem.color.forms.foreground.control
        .selected.indicator.interactive};
        }
      }
    `}

  &:disabled + ${StyledRadioIndicator} {
    border-color: ${(props) => props.theme.sem.color.forms.surface.control.default.stroke.disabled};
    background-color: ${(props) => props.theme.sem.color.forms.surface.control.default.fill.disabled};
  }

  &:checked:disabled + ${StyledRadioIndicator} {
    border-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.stroke.disabled};
    background-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.fill.disabled};
    &::before {
      background-color: ${(props) => props.theme.sem.color.forms.foreground.control.selected.indicator
    .disabled};
    }
  }
`;
export const StyledLabel = styled.label `
  cursor: pointer;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_150};
  align-items: flex-start;
  ${(props) => !props.invalid &&
    css `
      &:has(${StyledInput}:disabled) {
        cursor: not-allowed;
        ${StyledTextContent} {
          color: ${props.theme.sem.color.forms.foreground.text.disabled};
        }
      }

      &:has(${StyledInput}:hover:not(:disabled)) {
        ${StyledTextContent} {
          color: ${props.theme.sem.color.forms.foreground.text.interactive};
        }
      }
    `}

  ${(props) => props.invalid &&
    css `
      ${StyledTextContent} {
        color: ${props.theme.sem.color.forms.foreground.text.error};
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map